// src/lib/study-session/marker.ts
//
// The session marker a block's page carries: ?session=<id>.<block>.<step>.
// Which session the page belongs to, and which page of it this is — so its
// finish screen can hand off, and a stale tab can be told apart from the
// current one. Zero imports: the session bar and hand-off ship it to the
// browser, and nothing else should come with it.

export type SessionPosition = { block: number; step: number }

/** The query parameter a block's page carries while it is part of a session. */
export const SESSION_PARAM = 'session'

/** "<id>.<block>.<step>". */
export function sessionMarker(id: string, at: SessionPosition): string {
  return `${id}.${at.block}.${at.step}`
}

export function parseSessionMarker(
  raw: string | null | undefined,
): ({ id: string } & SessionPosition) | null {
  if (!raw) return null
  const m = /^([A-Za-z0-9_-]{1,64})\.(\d{1,2})\.(\d)$/.exec(raw.trim())
  if (!m) return null
  return { id: m[1], block: Number(m[2]), step: Number(m[3]) }
}
